import { render } from "./WhatsAppLoginModal.vue?vue&type=template&id=85a0e6ba"
import script from "./WhatsAppLoginModal.vue?vue&type=script&lang=js"
export * from "./WhatsAppLoginModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__